module.exports = __webpack_public_path__ + "static/media/arrow-left-white.5cb3992e.svg";